import {ListGroup, ListGroupItem, NavLink, Offcanvas, OffcanvasBody, OffcanvasHeader} from "reactstrap";
import { Link } from 'react-router-dom';
import { FaFacebookMessenger } from "react-icons/fa";
import { CgShoppingCart } from "react-icons/cg";
import React from "react";
import { Users } from "react-feather";
import { HiOutlineUserGroup } from "react-icons/hi";

const menuItems = [
    {link: '/community/shop', name: 'Shop', icon: <CgShoppingCart size={24} />, isAvailable: true},
    {link: '/community/message', name: 'Message', icon: <FaFacebookMessenger size={24} />, isAvailable: true},
    {link: '/community/members', name: 'Members', icon: <Users size={24} />, isAvailable: true},
    {link: '/community/group', name: 'Groups', icon: <HiOutlineUserGroup size={24} />, isAvailable: true},
]

const MobileMenu = ({open, toggle}) => {
// var(--theme-color)
    return (
        <div>
          <Offcanvas
            className=""
            direction="end"
            isOpen={open}
            toggle={toggle}
            // style={{width:"70%"}}
          >
            <div style={{backgroundColor:"var(--theme-color)",alignItems:"center",justifyContent:"center"}}>
              <OffcanvasHeader className="d-flex align-content-start w-100 h-100 py-2 ">
                <h3 className="mb-0 text-light ">Menu</h3>
              </OffcanvasHeader>
            </div>
            <OffcanvasBody style={{color:'black'}} className="p-0 pt-2">
              <div className="sidebar-menu mt-1">
                {menuItems?.map((service, index) => (
                  <React.Fragment key={index}>
                    <Link
                      to={service.link}
                      style={{textDecoration: 'none', color: 'inherit'}}
                      className="d-flex sidebar-item justify-content-between align-items-center w-100"
                      onClick={toggle}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          className="mobile-menu-icon me-1 sidebar-content"
                        >
                          {service.icon}
                        </div>
                        <h4 style={{color:"black"}} className="mb-0 sidebar-text">{service.name}</h4>
                      </div>
                    </Link>
                  </React.Fragment>
                ))}
              </div>

                <style jsx>{`
                  .sidebar-menu {
                    width: 100%;
                    margin: 0 auto 0 auto;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                  }

                  .sidebar-item {
                    display: flex;
                    align-items: center;
                    text-decoration: none;
                    color: #222;
                    font-size: 16px;
                    font-weight: 500;
                    padding: 12px 16px;
                    border-radius: 8px;
                    transition: all 0.1s ease-in-out;
                    background: white;
                  }

                  .sidebar-item:hover,
                  .sidebar-item.active {
                    background: var(--theme-color);
                    color: white !important;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                  }

                  .sidebar-content {
                    display: flex;
                    align-items: center;
                    gap: 9px;
                  }

                  .sidebar-text {
                    font-weight: 600;
                    font-size: 16px;
                  }
                `}</style>

            </OffcanvasBody>
          </Offcanvas>
        </div>
    );
};

export default MobileMenu;